import React, { useEffect,useState } from 'react'
import _ from 'lodash';
import { useNavigate, useParams } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { useAppDispatch } from '../../../../../../hooks/hooks';
import storePersist from '../../../../../../redux/storePersist';
import PageLoader from '../../../../../../components/PageLoader';
import LocationComponent from '../components/location.component';
import { stores } from '../../../../../../redux/stores/action';
import { selectStoresListItems } from '../../../../../../redux/stores/selector';
import { warehouses } from '../../../../../../redux/ware-houses/action';
import { selectWarehousesListItems } from '../../../../../../redux/ware-houses/selector';
import { locations } from '../../../../../../redux/locations/action';
import { selectLocationsQueryItems } from '../../../../../../redux/locations/selector';

const ManagementLocation = () => {  
  const navigate = useNavigate()
  const dispatch = useAppDispatch()
  const parmas: any = useParams()
  const LocationQuery = useSelector(selectLocationsQueryItems)
  const librariesItems = storePersist?.get("library")?.current;
const [isQuery, setIsQuery] = useState<boolean>(false)
const [isLoading, setIsLoading] = useState<boolean>(true)
const storeItems = useSelector(selectStoresListItems)
const warehouseItems = useSelector(selectWarehousesListItems)
const [
    selectedLocation,
    setSelectedLocation
  ] = useState<any>([])

  const fetchLocationsQueryById= ()=>{
    dispatch(locations.query({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/locations/query`,entity:'locations',jsonData:{
          
    Records: [
      {
        Id: parmas?.id
      }
    ]
  
}})).then(()=>{
  setIsQuery(true)
})




  }

  const handleInnerbasicFormChange: any = (event: any, field: string) => {
    setSelectedLocation({ ...selectedLocation, [field]: event })
  }
  
  useEffect(
    () => {
        dispatch(stores.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/stores/list`,entity:'stores',jsonData:{
          
    }}))
    .then(()=>{
        dispatch(warehouses.list({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/ware-houses/list`,entity:'warehouses',jsonData:{
          
        }}))
      }).then(()=>{
            if (parmas?.id > 0) {
                fetchLocationsQueryById()
                setIsLoading(false)
                } else{
                    setIsLoading(false) 
                }
          })
       
    },
    []
  )
  useEffect(
    () => {
        
      if (isQuery) {
        setSelectedLocation(LocationQuery?.result?.items)
    }
    },
    [isQuery]
  ) 
const handleFormSubmit  = async (event: any) => {
    event.preventDefault();
   
      if (parmas?.id > 0) {
     dispatch(locations.update({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/locations`,entity:'locations',jsonData:{
          
    Records: [
        selectedLocation
    ]
 
}})) .then(()=>{
    back()
  })
      }else{
        dispatch(locations.create({url:`https://api.digiit.${process.env.REACT_APP_API_URL}/api/v4.0/organization/organization-management/locations`,entity:'locations',jsonData:{
            
        Records: [
            selectedLocation
        ]
      
    }})).then(()=>{
        back()
      })
      }
  }
 
const back=()=>{
  navigate('/management/organization/organization-management/locations')
} 

    return (
        <>

        {isLoading ? <PageLoader /> : 
          <LocationComponent 
          serviceableStatus={librariesItems?.ServiceableStatus}
          handleFormSubmit={handleFormSubmit}
          back={back}
          stores={storeItems?.result?.items} 
          warehouses={warehouseItems?.result?.items}
          locationType={librariesItems?.LocationType}
          handleInnerbasicFormChange={handleInnerbasicFormChange}
          selectedLocation={selectedLocation} 
          /> 
    } 
          </>
    )
    
    }
   
    export default ManagementLocation;